export default __webpack_public_path__ + "static/media/WINE2.a26a8db2.jpg";